define('gameday-language/translator',['require','exports','module','./dictionary','mustache-language/translator'],function(require,exports,module){
    var dictionary = require( "./dictionary" );
    return require( "mustache-language/translator" );
});

